export const SliderData = [
  {
    image: "./images/slide1.png",
  },
  {
    image:
     "./images/slide2.png",
  },
  {
     image:
     "./images/slide3.png",
  },
 
];
